import { render, staticRenderFns } from "./BtnAtualizarValoresEmLoteItemContrato.vue?vue&type=template&id=066fef32"
import script from "./BtnAtualizarValoresEmLoteItemContrato.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarValoresEmLoteItemContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports